import { useState } from 'react'
import renderPrgImage from '../../../../source/programImg'
import style from './SideBar.module.css'
import { connect } from 'react-redux'

const SmallCard = ({
    stopFuntionRef,
    type,
    ind,
    card = {},
    keyS = '',
    setSelectInternalAccessories,
    isSelectInternalAccessories,
    // reduxInternalaccessories,
    graphPlotStorage,
    setSelectPorts,
    port,
    mainInd = 0,
    minorInd = 0,
    setTempScale,
    selectedTemperatureScale,
    // title,
    // color,
    // selected,
    // expanded,
    // onSelect,
    // onToggleExpand,
    // details,
}) => {
    let reduxInternalaccessories = graphPlotStorage.internalaccessories

    const [isExpandTemp, setIsExpandTemp] = useState(false)
    let isChecked = false
    let title = ''
    let bgColour = ''
    if (type === 'exterNalSensor') {
        if (!port.isActive) {
            return <></>
        }
        keyS = port.portName
        isChecked = port.isChecked
        title = 'Port ' + port.portName
        bgColour = port.isColor
    } else {
        if (
            [
                'distancesensor',
                'gesturesensor',
                'colorsensorRed',
                'colorsensorBlue',
                'colorsensorGreen',
                'lightsensor',
            ].includes(keyS)
        ) {
            if (!reduxInternalaccessories.Four_in_one_sensor[card.reduxName]) {
                return <></>
            }
        } else if (!reduxInternalaccessories[card.reduxName]) {
            return <></>
        }
        isChecked = isSelectInternalAccessories[card.reduxName]
        title = card.sensors
        bgColour = card.bgColour
    }

    const handleCardSelect = (e) => {
        try {
            e.stopPropagation()
            stopFuntionRef?.current()

            if (type === 'exterNalSensor') {
                setSelectPorts({ mainInd, minorInd, value: e.target.checked })
            } else {
                setSelectInternalAccessories({
                    key: card.reduxName,
                    value: e.target.checked,
                })
            }
            // setCards((prevCards) =>
            //     prevCards.map((card) =>
            //         card.id === cardId
            //             ? { ...card, selected: !card.selected }
            //             : card
            //     )
            // )
        } catch (e) {
            console.log('ERROR', e)
        }
    }

    const handleCardExpand = () => {
        if (card.reduxName === 'isTemperature') {
            setIsExpandTemp(!isExpandTemp)
        }
        // setCards((prevCards) =>
        //     prevCards.map((card) =>
        //         card.id === cardId
        //             ? { ...card, expanded: !card.expanded }
        //             : card
        //     )
        // )
    }

    const handelScaleClick = (e, scaleName) => {
        e.stopPropagation()
        setTempScale(scaleName)
    }

    return (
        <div className={style.cardContainer} key={keyS}>
            <div
                className={`${style.card} ${
                    isChecked ? style.cardSelected : ''
                }`}
                onClick={handleCardExpand}
            >
                <div className={style.cardHeader}>
                    <div className={style.cardTitle}>
                        <div
                            className={style.colorBox}
                            style={{ background: bgColour }}
                        ></div>
                        <span>{title}</span>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                    >
                        {card.reduxName === 'isTemperature' &&
                            (isExpandTemp ? (
                                // <ChevronDown style={styles.expandIcon} />
                                <img
                                    src={renderPrgImage('upArrow')}
                                    alt="up arrow button"
                                />
                            ) : (
                                // <ChevronRight style={styles.expandIcon} />
                                <img
                                    src={renderPrgImage('downArrow')}
                                    alt="down arrow button"
                                />
                            ))}
                    </div>
                </div>

                {isExpandTemp && card.reduxName === 'isTemperature' && (
                    <div className={style.cardDetails}>
                        {[
                            { label: 'C', value: 'C' },
                            { label: 'F', value: 'F' },
                            { label: 'K', value: 'K' },
                        ].map((detail, index) => (
                            <div
                                onClick={(e) =>
                                    handelScaleClick(e, detail.value)
                                }
                                key={index}
                                className={style.detailItem}
                            >
                                <span
                                    className={
                                        selectedTemperatureScale ===
                                        detail.value
                                            ? style.scaleSelected
                                            : ''
                                    }
                                >
                                    {detail.label}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <label className={style.checkboxWrapper}>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => {
                        handleCardSelect(e)
                    }}
                />
                <span className={style.checkmark}></span>
            </label>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        time: state.graphPlotStorage.time,
        isSelectInternalAccessories:
            state.graphPlotStorage.isSelectInternalAccessories,
        reduxInternalaccessories: state.graphPlotStorage.internalaccessories,
        selectedTemperatureScale:
            state.graphPlotStorage.selectedTemperatureScale,
        graphPlotStorage: state.graphPlotStorage,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectInternalAccessories: (data) => {
            dispatch({ type: 'SET_SELECT_INTERNAL_ACCESSORIES', payload: data })
        },
        setSelectPorts: (data) => {
            dispatch({ type: 'SET_SELECT_PORTS', payload: data })
        },
        setTempScale: (data) => {
            dispatch({ type: 'SET_TEMP_SCALE', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SmallCard)
